export default __webpack_public_path__ + "static/media/seller-login-bg.248c002f.png";